import { render, staticRenderFns } from "./TrafficGraph.vue?vue&type=template&id=2038063d&scoped=true&"
import script from "./TrafficGraph.vue?vue&type=script&lang=js&"
export * from "./TrafficGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2038063d",
  null
  
)

export default component.exports